<template>
  <div class="header">
    <div class="left">
        <div class="left_msg"><img src="@/assets/yklogo.png" alt=""></div>
        <div class="center"></div>
        <div class="right_msg">
            <div class="texts">
                <span>24年品牌律所</span>
                <span>全球化法律服务机构</span>
            </div>
            <div class="img21"><img src="@/assets/21.png" alt=""></div>
        </div>
    </div>
    <div class="right">
        <img src="@/assets/black_tel.png" alt=""><span>400-642-0148 </span>
    </div>
  </div>
</template>

<script>
export default {
    name:'Header',
}
</script>


<style scoped  lang="scss">
    .header{
        width: 1420px;
        height: 80px;
        margin: 0 auto;
        display: flex;
        align-items: center;
        justify-content: space-between;
    }
    .left{
        display: flex;
        align-items: center;
    }
    .left_msg img{
        width: 150px;
    }
    .right_msg{
        display: flex;
        align-items: center;
    }
    .center{
        margin: 20px;
        width: 2px;
        height: 40px;
        background: #DFDFDF;
    }
    .right_msg .texts{
        display: flex;
        flex-direction: column;
    }
    .right_msg .texts span:first-child{
        font-style: italic;
        font-weight: bold;
    }
    .right_msg .texts span:last-child{
        font-size: 12px;
        color: #666666;
    }
    .img21{
        margin-left: 10px;
    }
    .right{
        display: flex;
        align-items: center;
    }
    .right span{
        font-weight: bold;
        font-size: 16px;
        font-style: oblique;
    }
    .right img{
        margin-right: 10px;
    }
    
    @media screen and (max-width: 750px) {
    .header {
        display: none;
    }
    }
</style>